module.exports = __webpack_public_path__ + "img/718.a8f4b0ff.png";